import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import Home from '../containers/Home/Home';
import { useSelector } from 'react-redux';
import Header from '../components/Header/Header';
import AppServices from '../services/AppService';
import Footer from '../components/Footer/Footer';
import '../styles/WorkspacePages.scss';

const ForgetPassword = lazy(() =>
  import('../containers/ForgetPassword/ForgetPassword')
);
const Login = lazy(() => import('../containers/Login/Login'));
const ResendOtp = lazy(() => import('../containers/ResendOTP/ResendOtp'));
const VerifyEmail = lazy(() => import('../containers/VerifyEmail/VerifyEmail'));
const VerifyForgetPassword = lazy(() =>
  import('../containers/VerifyForgetPassword/VerifyForgetPassword')
);
const ProfilePage = lazy(() => import('../containers/profile/profile'));
const WalletPage = lazy(() => import('../containers/wallet/wallet'));
const CrowdDetails = lazy(() => import('../containers/HomePage/CrowdDetails'));
const PrivacyPage = lazy(() => import('../containers/privacy_page'));
const TradePage = lazy(() => import('../containers/Trade/TradePage'));
const Verify2fa = lazy(() => import('../containers/TwoFAPage/TwofaPage'));
const EscterPayScreen = lazy(() => import('../components/EscterPay/EscterPay'));
const Reset2fa = lazy(() => import('../containers/Reset2faPage/Reset2fa'));
const VerifyReset2fa = lazy(() =>
  import('../containers/Reset2faPage/VerifyReset2fa')
);
const FaqPage = lazy(() => import('../containers/faq/faq_page'));
const MyCrowdsale = lazy(() => import('../containers/MyCrowdsale/MyCrowdsale'));
const MyMusic = lazy(() => import('../containers/mymusic/my_music'));
const Support = lazy(() => import('../containers/support/Support'));
const Chat = lazy(() => import('../containers/support/Chat'));
const SecurityPage = lazy(() => import('../containers/2fa/security_page'));
const TermsCondition = lazy(() => import('../containers/TermsCondtion/Terms'));
const AboutUs = lazy(() => import('../containers/AboutUs/Aboutus'));
const ThankyouAver = lazy(() =>
  import('../containers/ThankyouAver/ThankyouAver')
);
const Portfolio = lazy(() => import('../containers/Portfolio/Portfolio'));
const LinkedDevices = lazy(() =>
  import('../containers/LinkedDevices/LinkedDevices')
);
const VerifyDevice = lazy(() =>
  import('../containers/DeviceVerify/DeviceVerify')
);
const AnchorWallet = lazy(() =>
  import('../containers/AnchorWallet/AnchorWallet')
);
const ProfileRegistration = lazy(() =>
  import('../containers/AnchorWallet/ProfileRegistration')
);
const Guide = lazy(() => import('../containers/Guide/Guide'));
const MusicNFT = lazy(() => import('../containers/NFT_Components/MusicNFT'));
const GenerateKey = lazy(() => import('../containers/GenerateKey/GenerateKey'));
const Swap = lazy(() => import('../containers/Swap/Swap'));
const StellarMobileView = lazy(() =>
  import('../containers/StellarMobileView/StellarMobileView')
);
const Bookmarks = lazy(() => import('../containers/Bookmark/Bookmark'));
const ProfileRegistrationLobstr = lazy(() =>
  import('../containers/AnchorWallet/ProfileRegistrationLobstr')
);
const ProfileRegistrationFreighter = lazy(() =>
  import('../containers/AnchorWallet/ProfileRegistrationFreighter')
);

const appService = new AppServices();
export const Routes = (props) => {
  const { cartdata } = useSelector((state) => state.crowdsale);
  const [showHeader, setShowHeader] = useState(true);

  const location = useLocation();
  const workspaceRoutes = [
    '/wallet',
    '/portfolio',
    '/profile',
    '/security',
    '/devices',
    '/bookmark',
    '/trade',
    '/mycrowdsale',
    '/support',
    '/chat',
    '/guide',
    '/aboutus',
    '/privacy',
    '/terms',
    '/swap',
    '/music-nfts',
    '/music',
  ];
  const workspacePath = workspaceRoutes.find(
    (path) =>
      location.pathname === path || location.pathname.startsWith(path + '/')
  );
  const offeringList = location.pathname.startsWith('/home/');
  const pageClass = workspacePath
    ? `tm-workspace-page tm-page-${workspacePath.slice(1)}`
    : offeringList
    ? 'tm-workspace-page tm-page-offerings'
    : '';

  useEffect(() => {
    if (
      [
        '/login',
        '/signup',
        '/generatekey',
        '/forgetpassword',
        '/verifypassword',
        '/resendotp',
        '/reset2fa',
        '/verifyreset2fa',
        '/thank-you',
        '/verify2fa',
        '/profileRegistrationLobstr',
        '/profileRegistrationFreighter',
      ].find(
        (el) =>
          el === location.pathname ||
          location.pathname.startsWith('/profileRegistration/')
      )
    ) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [location.pathname]);

  return (
    <>
      {showHeader && <Header ual={props.ual} />}
      <div
        className={`main-content ${pageClass}`}
        style={{ flex: 1, width: '100%' }}
      >
        <Suspense
          fallback={
            <div className="text-center py-5" role="status">
              Loading page…
            </div>
          }
        >
          <Switch>
            <Route
              exact
              path="/stellarMobileView"
              render={() => <StellarMobileView />}
            />
            <Route
              exact
              path="/login"
              render={() =>
                !localStorage.getItem('token') ? (
                  <Login {...props} />
                ) : (
                  <Redirect to="/home" />
                )
              }
            />
            {/* <Route
            exact
            path="/home"
            render={() =>
              localStorage.getItem("token") ? (
                <Home {...props} />
              ) : (
                <Redirect to="/login" />
              )
            }
          /> */}
            <Route exact path="/home" render={() => <Home {...props} />} />
            <Route
              exact
              path="/profile"
              render={() =>
                localStorage.getItem('token') ? (
                  <ProfilePage {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/trade"
              render={() =>
                localStorage.getItem('token') ? (
                  <TradePage {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            {!(appService.isLogin() || props.ual.activeUser) ? (
              <Route
                exact
                path="/wallet"
                render={() =>
                  localStorage.getItem('token') ? (
                    <WalletPage {...props} />
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
            ) : (
              <Route
                exact
                path="/wallet"
                render={() =>
                  localStorage.getItem('token') ? (
                    <AnchorWallet {...props} />
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
            )}
            <Route
              exact
              path="/security"
              render={() =>
                localStorage.getItem('token') ? (
                  <SecurityPage {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/music-nfts/:id"
              render={() =>
                localStorage.getItem('token') ? (
                  <MusicNFT {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route path={`/privacy`} component={PrivacyPage} />
            {/*

          <Route
            exact
            path="/artist"
            render={() =>
              localStorage.getItem("token") ? (
                <ArtistPage {...props} />
              ) : (
                <Redirect to="/login" />
              )
            }
          /> */}
            <Route path={`/faq`} component={FaqPage} />
            <Route path={`/generatekey`} component={GenerateKey} />
            <Route path={`/terms`} component={TermsCondition} />
            <Route path={`/aboutus`} component={AboutUs} />
            <Route
              path={`/home/:id`}
              render={() => <CrowdDetails {...props} />}
            />
            {/* <Route exact path="/signup" render={(props) => <Signup {...props} />} /> */}
            <Route
              exact
              path="/verify-email"
              render={() => <VerifyEmail {...props} />}
            />
            <Route
              exact
              path="/verify-device"
              render={() =>
                localStorage.getItem('token') ? (
                  <Redirect to="/login" />
                ) : (
                  <VerifyDevice {...props} />
                )
              }
            />
            <Route
              exact
              path="/verify2fa"
              render={() =>
                localStorage.getItem('token') ? (
                  <Redirect to="/login" />
                ) : (
                  <Verify2fa {...props} />
                )
              }
            />
            <Route
              exact
              path="/payment/:id/:crowdsaleid/:amount"
              render={() =>
                localStorage.getItem('token') ? (
                  <EscterPayScreen {...props} cartdata={cartdata} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/music"
              render={() =>
                localStorage.getItem('token') ? (
                  <MyMusic {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/portfolio"
              render={() =>
                localStorage.getItem('token') ? (
                  <Portfolio {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/devices"
              render={() =>
                localStorage.getItem('token') ? (
                  <LinkedDevices {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/bookmark"
              render={() =>
                localStorage.getItem('token') ? (
                  <Bookmarks {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route exact path="/forgetpassword" component={ForgetPassword} />
            <Route
              exact
              path="/verifypassword"
              component={VerifyForgetPassword}
            />
            <Route exact path="/resendotp" component={ResendOtp} />
            <Route exact path="/reset2fa" component={Reset2fa} />
            <Route exact path="/verifyreset2fa" component={VerifyReset2fa} />
            <Route exact path="/thank-you" component={ThankyouAver} />
            {/* <Route exact path="/2fa" component={TwoFactorAuth} /> */}
            <Route
              exact
              path="/mycrowdsale"
              render={() =>
                localStorage.getItem('token') ? (
                  <MyCrowdsale {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/support"
              render={() =>
                localStorage.getItem('token') ? (
                  <Support {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            {/* SWAP */}
            <Route
              exact
              path="/swap"
              render={() =>
                localStorage.getItem('token') ? (
                  <Swap {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            {/* SWAP */}
            <Route
              exact
              path="/chat/:id"
              render={() =>
                localStorage.getItem('token') ? (
                  <Chat {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/guide"
              render={(props) =>
                localStorage.getItem('token') ? (
                  <Guide {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
            <Route
              exact
              path="/profileRegistration/:id"
              render={() =>
                appService.isLogin() ? (
                  <ProfileRegistration {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            ></Route>
            <Route
              exact
              path="/profileRegistrationLobstr"
              render={(props) => <ProfileRegistrationLobstr {...props} />}
            />
            <Route
              exact
              path="/profileRegistrationFreighter"
              render={(props) => <ProfileRegistrationFreighter {...props} />}
            />
            <Route path="/">
              <Redirect to="/home" />
            </Route>
          </Switch>
        </Suspense>
      </div>
      {showHeader && <Footer />}
    </>
  );
};
